<template>
  <div class="activity-wrap">
    <app-header />
    <div class="cysw">
      <div class="header">
        <div class="w866">
          <p style="padding-top: 50px;">
            <img
              src="../../assets/images/activity/cysw/cysw01.png"
              alt=""
              class="title"
            />
          </p>

          <p style="margin-top: 18px;" @click="nowOpen()">
            <img
              src="../../assets/images/activity/cysw/cysw02.png"
              alt=""
              class="ktbtn"
            />
          </p>

          <p style="margin-top: 30px;">
            <img src="../../assets/images/activity/cysw/cysw03.png" alt="" />
          </p>

          <div
            class="w866"
            style="width: 866px; height: 561px; margin:0 auto;margin-top: 18px;"
          >
            <div class="bg0703">
              <div class="carousel1">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  height="561px"
                  @mouseenter="isAutoplay1 = false"
                  @mouseleave="isAutoplay1 = true"
                  :autoplay="isAutoplay1"
                >
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/cysw/cysw05_01.jpg"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/cysw/cysw05_02.jpg"
                      alt=""
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>

          <p style="margin-top: 50px;">
            <img src="../../assets/images/activity/cysw/cysw04.png" alt="" />
          </p>

          <div
            class="w866"
            style="width: 866px; height: 648px; margin:0 auto;margin-top: 18px;"
          >
            <div class="bg0703">
              <div class="carousel1">
                <el-carousel
                  :interval="3000"
                  arrow="always"
                  height="648px"
                  @mouseenter="isAutoplay1 = false"
                  @mouseleave="isAutoplay1 = true"
                  :autoplay="isAutoplay1"
                >
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/cysw/cysw06_01.jpg"
                      alt=""
                    />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img
                      src="../../assets/images/activity/cysw/cysw06_02.jpg"
                      alt=""
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
          </div>

          <p style="margin-top: 18px;" @click="nowOpen()">
            <img
              src="../../assets/images/activity/cysw/cysw02.png"
              alt=""
              class="ktbtn"
            />
          </p>

          <p style="margin-top: 18px;">
            <img src="../../assets/images/activity/cysw/cysw08.jpg" alt="" />
          </p>

          <p style="margin-top: 18px;" @click="nowOpen()">
            <img
              src="../../assets/images/activity/cysw/cysw02.png"
              alt=""
              class="ktbtn"
            />
          </p>
        </div>
      </div>

      <div class="risk_warning">
        风险提示：本产品不涉及投资咨询及投资顾问服务，所展示信息不构成投资建议；数据基于历史，不代表未来趋势；所有工具都有局限性，适合不同情况下的市场，仅供参考，请理性投资，控制风险。/
        广告
      </div>
    </div>
  </div>
</template>
<script>
import AppHeader from "@/components/common/AppHeader.vue";
export default {
  components: {
    AppHeader
  },
  data () {
    return {
      s: this.$route.query.s,
    }
  },
  watch: {},
  created() {
    if(!this.s){
      this.s = "";
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    nowOpen() {
      var routerDate = this.$router.resolve({name: 'OrderConfirm', params:{productId: 73,month: 12}})
      let {href} = routerDate;
      window.location.href = href + "?s=" + this.s;
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.cysw >>> .el-carousel__arrow {
  box-shadow: 0 0 6px rgba(255, 255, 255, 1);
  background: rgba(31, 45, 61, 0.41);
  width: 60px;
  height: 60px;
  font-size: 25px;
  font-weight: bold;
}

.w866 {
  width: 866px;
  margin: 0 auto;
  .bg0703 {
    position: relative;
    .ljqg {
      width: 535px;
      height: 89px;
      position: absolute;
      left: 50%;
      bottom: -70px;
      margin-left: -267.5px;
      cursor: pointer;
      animation: click-animation 1.2s infinite;
      @keyframes click-animation {
        0%,
        100% {
          transform: scale(1);
        }
        50% {
          transform: scale(0.9);
        }
      }
    }

    .agreement {
      color: #fff;
      font-size: 14px;
      width: 535px;
      height: 89px;
      position: absolute;
      left: 50%;
      bottom: -140px;
      margin-left: -267.5px;
      text-align: center;
    }
    .carousel1 {
      border: 1px solid rgba(255, 0, 0, 0);
    }
  }
}

.cysw {
  background: #152139;
  .header {
    background: url("../../assets/images/activity/cysw/bg.png") no-repeat center
      top;

    text-align: center;

    .w866 {
      width: 866px;
      margin: 0 auto;
    }
  }

  .ktbtn {
    cursor: pointer;
    animation: click-animation 1.2s infinite;
    @keyframes click-animation {
      0%,
      100% {
        transform: scale(1);
      }
      50% {
        transform: scale(0.9);
      }
    }
  }

  .risk_warning {
    text-align: center;
    color: #6a6a6a;
    font-size: 12px;
    padding: 30px 0 50px;
    line-height: 22px;
    opacity: 0.5;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/cysw.vue